import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/img/tool-blue.png';
import _imports_1 from '../../assets/img/tool-green.png';
import _imports_2 from '../../assets/img/tool-grey.png';
import _imports_3 from '../../assets/img/icon-1.png';
import _imports_4 from '../../assets/img/icon-2.png';
import _imports_5 from '../../assets/img/icon-3.png';
import _imports_6 from '../../assets/img/icon-4.png';
const _hoisted_1 = {
  class: "remote"
};
const _hoisted_2 = {
  class: "remote-imgbox"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_5 = {
  class: "messagebox"
};
const _hoisted_6 = {
  class: "number"
};
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = {
  class: "item"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1);
const _hoisted_10 = {
  class: "messagebox"
};
const _hoisted_11 = {
  class: "number"
};
const _hoisted_12 = {
  class: "text"
};
const _hoisted_13 = {
  class: "item"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1);
const _hoisted_15 = {
  class: "messagebox"
};
const _hoisted_16 = {
  class: "number"
};
const _hoisted_17 = {
  class: "text"
};
const _hoisted_18 = {
  key: 0,
  class: "item chart",
  id: "equipmentChart"
};
const _hoisted_19 = {
  class: "remote-listbox"
};
const _hoisted_20 = {
  class: "list-header"
};
const _hoisted_21 = {
  class: "select-box"
};
const _hoisted_22 = {
  class: "titlebox"
};
const _hoisted_23 = ["title"];
const _hoisted_24 = {
  key: 0,
  class: "status on-line"
};
const _hoisted_25 = {
  key: 1,
  class: "status off-line"
};
const _hoisted_26 = {
  key: 2,
  class: "off-line-time"
};
const _hoisted_27 = {
  class: "messagebox"
};
const _hoisted_28 = {
  class: "message-item"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1);
const _hoisted_30 = {
  class: "message-item"
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1);
const _hoisted_32 = {
  class: "message-item small"
};
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1);
const _hoisted_34 = {
  class: "message-item"
};
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1);
const _hoisted_36 = {
  class: "message-item"
};
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1);
const _hoisted_38 = {
  class: "link-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_link = _resolveComponent("el-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", null, _toDisplayString(_ctx.$t("message.deviceManagement")), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString($setup.summary.total), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("message.total")), 1)])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, _toDisplayString($setup.summary.online), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("message.online")), 1)])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, _toDisplayString($setup.summary.offline), 1), _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("message.offline")), 1)])]), $setup.echartsShow ? (_openBlock(), _createElementBlock("div", _hoisted_18)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("message.devices")), 1), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_select, {
    modelValue: $setup.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.value = $event),
    placeholder: _ctx.$t('message.pleaseSelect'),
    "popper-class": "firmware-select",
    "no-data-text": _ctx.$t('message.noData'),
    onChange: $setup.hanldeSelectChange
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: _ctx.$t('message.all'),
      value: "all"
    }, null, 8, ["label"]), _createVNode(_component_el_option, {
      label: _ctx.$t('message.online2'),
      value: "online"
    }, null, 8, ["label"]), _createVNode(_component_el_option, {
      label: _ctx.$t('message.offline2'),
      value: "offline"
    }, null, 8, ["label"])]),
    _: 1
  }, 8, ["modelValue", "placeholder", "no-data-text", "onChange"])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.remoteList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "list-item",
      key: index
    }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("p", {
      class: "title",
      title: item.name
    }, _toDisplayString(item.name || ""), 9, _hoisted_23), item.status === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t("message.online2")), 1)) : _createCommentVNode("", true), item.status === -1 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t("message.offline2")), 1)) : _createCommentVNode("", true), item.status === -1 ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t("message.offlineTime")) + "：" + _toDisplayString(item.offlineTime || ""), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.model2")) + "：" + _toDisplayString(item.deviceType || _ctx.$t("message.unknown")), 1)]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("p", null, "Mac：" + _toDisplayString(item.mac || _ctx.$t("message.unknown")), 1)]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.firmwareVersion")) + "：" + _toDisplayString(item.otaVersion || _ctx.$t("message.unknown")), 1)]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.intranetIP")) + "：" + _toDisplayString(item.internalIp || _ctx.$t("message.unknown")), 1)]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.internetIP")) + "：" + _toDisplayString(item.outerIp || _ctx.$t("message.unknown")), 1)])]), _createElementVNode("div", _hoisted_38, [item.status === 0 ? (_openBlock(), _createBlock(_component_el_link, {
      key: 0,
      type: "primary",
      class: "online-link",
      onClick: $event => $setup.goToLink(item)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.access")), 1)]),
      _: 2
    }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_link, {
      key: 1,
      disabled: ""
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.access")), 1)]),
      _: 1
    }))])]);
  }), 128))])]);
}